/*
  EcomHub Pro - smooth open and close for Dawn's collapsible rows.

  A <details> element shows and hides its content outright, and a height cannot
  be transitioned from auto, so neither half of the movement can be done in CSS.
  This takes the toggle over: on opening it sets the element open, measures the
  content, and animates from zero to that height; on closing it animates back
  down first and only then clears the open attribute, so the content is still
  there to be seen on the way out.

  Everything is driven off data attributes on the section wrapper, and it falls
  back to the browser's own behaviour if anything is missing.
*/
(function () {
  function init(root) {
    if (root.__ehpAcc) return;
    root.__ehpAcc = true;

    var speed = (parseFloat(root.getAttribute('data-ehp-acc-speed')) || 0.4) * 1000;
    var fade = root.getAttribute('data-ehp-acc-fade') === '1';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    root.querySelectorAll('details').forEach(function (details) {
      var summary = details.querySelector('summary');
      var content = details.querySelector('.accordion__content');
      if (!summary || !content) return;

      var running = null;

      function cleanup() {
        content.style.overflow = '';
        content.style.height = '';
        content.style.margin = '';
        content.style.padding = '';
        content.style.opacity = '';
        content.style.transition = '';
        running = null;
      }

      /*
        The row's own margin and vertical padding sit OUTSIDE the height being
        animated, so animating height alone leaves that space appearing and
        disappearing in one step - the jump at each end of the movement. They
        are collapsed and restored alongside it so the whole block moves as one.
      */
      function boxOf() {
        var cs = getComputedStyle(content);
        return {
          height: content.scrollHeight,
          marginTop: cs.marginTop,
          marginBottom: cs.marginBottom,
          paddingTop: cs.paddingTop,
          paddingBottom: cs.paddingBottom,
        };
      }

      function animate(opening, done) {
        if (running) running.cancel();
        var box = boxOf();
        var shut = {
          height: '0px',
          marginTop: '0px',
          marginBottom: '0px',
          paddingTop: '0px',
          paddingBottom: '0px',
        };
        var full = {
          height: box.height + 'px',
          marginTop: box.marginTop,
          marginBottom: box.marginBottom,
          paddingTop: box.paddingTop,
          paddingBottom: box.paddingBottom,
        };
        if (fade) {
          shut.opacity = 0;
          full.opacity = 1;
        }
        content.style.overflow = 'hidden';
        running = content.animate(opening ? [shut, full] : [full, shut], {
          duration: speed,
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        });
        running.onfinish = function () {
          cleanup();
          if (done) done();
        };
        running.oncancel = function () { running = null; };
      }

      summary.addEventListener('click', function (e) {
        /* no Web Animations or reduced motion: leave the browser to it */
        if (reduce || !content.animate) return;
        e.preventDefault();

        if (details.open) {
          details.classList.add('ehp-closing');
          animate(false, function () {
            details.open = false;
            details.classList.remove('ehp-closing');
          });
        } else {
          details.open = true;
          animate(true);
        }
      });
    });
  }

  function boot(scope) {
    var el = scope && scope.querySelectorAll ? scope : document;
    el.querySelectorAll('[data-ehp-acc]').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target || document);
  });
  document.addEventListener('DOMContentLoaded', function () { boot(); });
  boot();
})();
